import Data from './data';
import ResourceItem from './resourceItem';

export default class Create {
	constructor(resourceType) {
		this.termIds = '';
		this.resourceType = resourceType;
		this.data = [];
		this.totalItemCount = 0;
		this.curItemCount = 0; // Count of current items displaying.
		this.page = 1;
		this.currentPage = 0;
		this.viewMoreBtn = document.querySelector('.em-content-category__view-more');
		this.container = document.querySelector('.em-content-category__container');
		this.maxCount = 16;
		this.maxPageCount = null;
	}

	html() {
		let output = '';
		if (typeof this.data !== 'undefined') {
			const resourcePosts = this.data;

			Object.values(resourcePosts).forEach((postItem) => {
				const item = postItem;
				const resourceItem = new ResourceItem(item);
				output += resourceItem.html();
			});
		}
		return output;
	}

	setResults(termIds) {
		const { resourceType, container } = this;

		const categoryData = new Data(termIds, resourceType, this.page);
		categoryData.fetch((data, count, page) => {
			this.data = data;
			this.currentPage = page;

			this.totalItemCount = count;
			this.curItemCount = this.data.length;

			if (this.data.length) {
				// We Set the given html here.
				setTimeout(() => {
					container.innerHTML = this.html();
				}, 200);

				// Determine the display of the view more button based on count.
				if (this.totalItemCount > 16) {
					this.viewMoreBtn.style.display = 'inline-block';
					this.viewMoreBtn.setAttribute('data-page', this.currentPage);
					this.viewMoreBtn.setAttribute('data-count', this.totalItemCount);
				} else {
					this.viewMoreBtn.style.display = 'none';
				}
			} else {
				container.innerHTML = '<div class="em-content-category__container--empty"><p>No Resources found.</p></div>';
			}
		});
	}

	/**
	 * Append paginated results.
	 */
	appendResults(maxPageCount, currentPage, type, termIds) {
		this.paginationType = parseInt(type);
		this.currentPage = currentPage + 1;
		this.maxPageCount = maxPageCount;
		this.getPaginatedData(termIds);
	}

	/**
	 * Helps set the type of pagination to use.
	 */
	setPaginationType(type) {
		this.paginationType = parseInt(type);
	}

	getPaginatedData(termIds) {
		const nextPage = this.currentPage;
		const { resourceType, container } = this;
		const categoryData = new Data(termIds, resourceType, nextPage);
		categoryData.fetch((data, count, page) => {
			this.currentPage = page;
			this.data = data;
			container.innerHTML += this.html();

			this.viewMoreBtn.setAttribute('data-page', this.currentPage);
			if (this.viewMoreBtn.classList.contains('loading')) {
				this.viewMoreBtn.classList.remove('loading');
				this.viewMoreBtn.innerText = 'VIEW MORE';
			}

			// Hide view more button if we've reached our max page count.
			if (this.maxPageCount === this.currentPage) {
				this.viewMoreBtn.style.display = 'none';
			}
		});
	}
}
